import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const requiredKeys = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_APP_ID',
];

export function isFirebaseConfigured() {
  return requiredKeys.every((key) => {
    const value = process.env[key];
    return value && value !== 'your-api-key' && !value.startsWith('your-');
  });
}

export function getMissingFirebaseKeys() {
  return requiredKeys.filter((key) => {
    const value = process.env[key];
    return !value || value === 'your-api-key' || value.startsWith('your-');
  });
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let app = null;
let auth = null;
let googleProvider = null;

export function getFirebaseAuth() {
  if (!isFirebaseConfigured()) {
    return null;
  }

  if (!auth) {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    googleProvider = new GoogleAuthProvider();
    googleProvider.setCustomParameters({ prompt: 'select_account' });
  }

  return auth;
}

export function getGoogleProvider() {
  getFirebaseAuth();
  return googleProvider;
}
